
import {Vue, Prop, Component, Watch } from 'vue-property-decorator'
import { PassengerGroup } from '@/models/PassengerGroup';

@Component({
    components: {

    }
})
export default class PassengerGroupMultiSelect extends Vue {

  @Prop({ default: null }) organizationId: string | null;
  @Prop({ default: () => []}) value: number[];
  @Prop({ default: null}) selectAllValue: number | null;

  get passengerGroupIds(): number[] {
    return this.value;
  }

  set passengerGroupIds(newValue: number[]) {
    this.$emit('input', newValue);
  }

  get passengerGroups(): PassengerGroup[] {
    const passengerGroups = this.getPassengerGroupsFromStore();

    if (this.selectAllValue !== null) {
      passengerGroups.unshift({ id: this.selectAllValue, name: this.$t('generic.all') } as PassengerGroup);
    }

    return passengerGroups;
  }

  getPassengerGroupsFromStore(): PassengerGroup[] {
    if (!this.organizationId) {
      return [];
    }
    return (this.$store.state.organization.passengerGroups as PassengerGroup[]).filter(d => d.organizationId === this.organizationId);
  }
}
